module.exports = __webpack_public_path__ + "static/media/nico_vonau_color.6cf9ea53.jpg";